/*
 * Copyright (c) 2022 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 14/7/2022
 */

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useDeleteOfferMutation } from "../../Store/Services/OfferService";
import { closeOfferModal } from "../../Store/Slices/offerSlice";
import DeletePopUp from "../Shared/DeletePopUp";

const DeleteOffer = () => {
  const dispatch = useDispatch();
  const offer = useSelector((state) => state.offer);

  const [deleteOffer] = useDeleteOfferMutation();

  const onDeleteConfirm = async () => {
    const id = offer.selectedOffer;
    try {
      const response = await deleteOffer(id);
      const deletedOffer = response.data; 
      toast.success("Offer successfully deleted!", {position:'bottom-right'});
    } catch (err) {
      console.error("Failed to delete offer: ", err);
      toast.error("Error, something went wrong!", {position:'bottom-right'});
    }
    dispatch(closeOfferModal());
  };

  return (
    <DeletePopUp
      data="Offer"
      close={() => dispatch(closeOfferModal())}
      onDeleteConfirm={onDeleteConfirm}
    />
  );
};

export default DeleteOffer;
